// Single source of truth for how a testimonial-request status renders in the
// vendor app: badge colour + the i18n key for its label. Keeps the request
// detail page and any other consumer from re-deriving this mapping (and from
// drifting on the REJECTED variants, which depend on who rejected).

export interface RequestStatusDisplay {
  badgeClass: string;
  /** i18n key under `testimonials.status.*` */
  labelKey: string;
}

export function requestStatusDisplay(
  status: string,
  rejectedByRole?: string | null,
): RequestStatusDisplay {
  switch (status) {
    case 'VENDOR_REQUESTED':
      return { badgeClass: 'bg-blue-100 text-blue-800', labelKey: 'testimonials.status.requested' };
    case 'PROMOTER_APPROVED':
      return { badgeClass: 'bg-green-100 text-green-800', labelKey: 'testimonials.status.promoterApproved' };
    case 'VENDOR_APPROVED':
      return { badgeClass: 'bg-green-100 text-green-800', labelKey: 'testimonials.status.approved' };
    case 'REJECTED': {
      const labelKey =
        rejectedByRole === 'PROMOTER'
          ? 'testimonials.status.rejectedByPromoter'
          : rejectedByRole === 'SYSTEM'
            ? 'testimonials.status.rejectedBySystem'
            : 'testimonials.status.rejectedByVendor';
      return { badgeClass: 'bg-red-100 text-red-800', labelKey };
    }
    default:
      return { badgeClass: 'bg-gray-100 text-gray-800', labelKey: status };
  }
}
